import React from 'react';
import AtlasV2MetricSpineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2MetricSpineChart';

const AtlasV2TotalTrafficKeywordCount = () => {
  return (
    <AtlasV2MetricSpineChart
      indexName="traffic"
      fieldName="searchTerm"
      title="Keyword Count with Total Traffic"
      requestBuilder={(builder) => builder.addConditionRangeFilter('totalClicks', 1)}
    />
  );
};

export default AtlasV2TotalTrafficKeywordCount;
